import { toast } from 'shared/components'
import { tWithNamespace } from 'shared/hooks/use-loco-translation'

async function copyTextToClipboard(
  text: string,
  showSuccessToast = true,
): Promise<boolean> {
  try {
    if (typeof document !== 'undefined' && !document.hasFocus()) throw new Error()

    await navigator.clipboard.writeText(text)
    if (showSuccessToast) toast.success(tWithNamespace('global.copy_clipboard'))
    return true
  } catch {
    toast.error(tWithNamespace('global.error'))
    return false
  }
}

export { copyTextToClipboard }
